<div
  class="dot-button"
  role="button"
  tabindex="0"
  [class.active]="currentlySelected()"
  (click)="handleClick()"
  (keydown.enter)="handleClick()"
  (keydown.space)="handleClick()">
</div>
